import { createApiActions } from 'iqvia-shared';

import {
  GET_ACTIVITY_TYPES_URL,
  GET_CHANNELS_URL,
  GET_ISHCOENABLED_URL,
  GET_LIMITS_URL,
  GET_METRICS_URL,
  GET_TIME_PERIODS_URL,
  GET_USER_DATA_URL,
} from '../constants';
import apiNameEnums from '../../../Enums/apiNames';

export const fetchTimePeriods = () =>
  createApiActions(apiNameEnums.GET_TIME_PERIODS, {
    url: GET_TIME_PERIODS_URL,
    actionTypeOverrides: {
      success: {
        payload: (action, state, response) =>
          response.json().then(json => ({
            periods: json,
          })),
      },
    },
  });

export const fetchChannels = id =>
  createApiActions(apiNameEnums.GET_CHANNELS, {
    url: GET_CHANNELS_URL.replace('{buId}', id),
    actionTypeOverrides: {
      success: {
        payload: (action, state, response) =>
          response.json().then(json => ({
            channels: json,
          })),
      },
    },
  });

export const fetchLimits = id =>
  createApiActions(apiNameEnums.GET_LIMITS, {
    url: GET_LIMITS_URL.replace('{buId}', id),
  });

export const fetchUserData = (rootMID, token) =>
  createApiActions(apiNameEnums.GET_USER_DATA, {
    url: GET_USER_DATA_URL.replace('{rootMID}', rootMID).replace('{token}', token),
  });

export const fetchMetrics = () =>
  createApiActions(apiNameEnums.GET_METRICS, {
    url: GET_METRICS_URL,
    actionTypeOverrides: {
      success: {
        payload: (action, state, response) =>
          response.json().then(json => ({
            metrics: json,
          })),
      },
    },
  });

export const fetchActivityTypes = () =>
  createApiActions(apiNameEnums.GET_ACTIVITY_TYPES, {
    url: GET_ACTIVITY_TYPES_URL,
    actionTypeOverrides: {
      success: {
        payload: (action, state, response) =>
          response.json().then(json => ({
            activityTypes: json,
          })),
      },
    },
  });

export const fetchIsHCOEnabled = id =>
  createApiActions(apiNameEnums.GET_ISHCOENABLED, {
    url: GET_ISHCOENABLED_URL.replace('{buId}', id),
    actionTypeOverrides: {
      success: {
        payload: (action, state, response) =>
          response.json().then(json => ({
            isHCOEnabled: json,
          })),
      },
    },
  });



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/actions/index.js